export default __webpack_public_path__ + "static/media/Version (1) - Early Prop_14.0d8df619.jpg";